export const DOM_TARGET_REF_PREFIX = '__dom_path__:';

export const isDomTargetRef = (value?: string | null) =>
  Boolean(value && value.startsWith(DOM_TARGET_REF_PREFIX));

export const buildDomTargetRef = (root: Node, target: Node): string | undefined => {
  if (!root || !target || root === target) return undefined;

  const segments: number[] = [];
  let current: Node | null = target;

  while (current && current !== root) {
    const parent: Node | null = current.parentNode;
    if (!parent) return undefined;

    const index = Array.prototype.indexOf.call(parent.childNodes, current);
    if (index < 0) return undefined;

    segments.unshift(index);
    current = parent;
  }

  if (current !== root || segments.length === 0) return undefined;
  return `${DOM_TARGET_REF_PREFIX}${segments.join('.')}`;
};

export const resolveDomTargetRef = (root: Node, ref?: string | null): Node | null => {
  if (!root || !isDomTargetRef(ref)) return null;

  const rawPath = String(ref).slice(DOM_TARGET_REF_PREFIX.length).trim();
  if (!rawPath) return null;

  const indexes = rawPath
    .split('.')
    .map((segment) => Number.parseInt(segment, 10))
    .filter((segment) => Number.isFinite(segment) && segment >= 0);

  if (!indexes.length) return null;

  let current: Node | null = root;
  for (const index of indexes) {
    current = current?.childNodes?.[index] || null;
    if (!current) return null;
  }

  return current;
};
